import { Form } from '@ampol/design-system';
import { CardModalFormNames } from './types/CardModalFormNames';
import { ModalSection } from './ModalSection';
import { AUSSIE_STATES } from 'utilities/constants';

export default function CardModalDeliveryAddress() {
  return (
    <div>
      <h3>Delivery address</h3>
      <ModalSection first last>
        <Form.Input name={CardModalFormNames.ContactFirstName} label="Contact first name" />
        <Form.Input name={CardModalFormNames.ContactLastName} label="Contact last name" />
      </ModalSection>
      <ModalSection first last>
        <Form.Input name={CardModalFormNames.AddressLineOne} label="Address line 1" />
        <Form.Input name={CardModalFormNames.AddressLineTwo} label="Address line 2" />
      </ModalSection>
      <ModalSection first>
        <Form.Input name={CardModalFormNames.City} label="City" />
        <Form.DropdownSearch
          name={CardModalFormNames.State}
          label="State"
          data={AUSSIE_STATES}
          placeholder="Select state"
        />
        <Form.Input name={CardModalFormNames.Postcode} label="Postcode" />
      </ModalSection>
    </div>
  );
}
